import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import IncidentLog from '../IncidentLog'

  export const GetDashboardTopDriver = createAsyncThunk('appDashboard/GetTopDriver', async (GetDriver) => {
    const response = await axios.post('https://api.zasway.com:8443/Dashboard/GetDashboardTopDriver', GetDriver, { mode: 'cors' })
    return response.data
  })

  export const GetDashboardTopClient = createAsyncThunk('appDashboard/GetTopClient', async (GetClient) => {
    const response = await axios.post('https://api.zasway.com:8443/Dashboard/GetDashboardTopClient', GetClient, {mode:'cors'})
    return response.data
  })

  export const getBookingsGraph = createAsyncThunk('appDashboard/getBookingsGraph', async (Bookings) => {
    const response = await axios.post('https://api.zasway.com:8443/Dashboard/GetBookingsGraph', Bookings, {mode:'cors'})
    return {
      data: response.data
    }
  })

  export const getGoalOverview = createAsyncThunk('appDashboard/getGoalOverview', async (GoalOverview) => {
    const response = await axios.post('https://api.zasway.com:8443/Dashboard/GetGoalOverview', GoalOverview, {mode:'cors'})
    return {
      data: response.data
    }
  })
    export const getBookingPayments = createAsyncThunk('appDashboard/getBookingPayments', async (GoalOverview) => {
    const response = await axios.post('https://api.zasway.com:8443/Dashboard/GetPendingBookingPayments', GoalOverview, {mode:'cors'})
    return {
      data: response.data
    }
  })
 
  export const getGoalOverviews = createAsyncThunk('appDashboard/getGoalOverviews', async (GoalOverviews) => {
    const response = await axios.post('https://api.zasway.com:8443/Dashboard/GetGoalOverview', GoalOverviews, {mode:'cors'})
    return {
      data: response.data
    }
  })

  export const getDashboardSources = createAsyncThunk('appDashboard/getDashboardSources', async (GoalOverview) => {
    const response = await axios.post('https://api.zasway.com:8443/Dashboard/GetDashboardSources', GoalOverview, {mode:'cors'})
    return {
      data: response.data
    }
  })

  export const getDashboardAllData = createAsyncThunk('appDashboard/getDashboardAllData', async (DashboardAllData) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Dashboard/GetDashboardAllData', DashboardAllData, {mode:'cors'})
    return {
      data: response.data
    }
  })

  export const getDriverDocuments = createAsyncThunk('appDashboard/GetDriverDocuments', async (GetDriverDocuments) => {
       
    const response = await axios.post('https://api.zasway.com:8443/Dashboard/GetDashboardDriverDocuments', GetDriverDocuments, { mode: 'cors' })
      
    return response.data
  })
  export const getVehicleDocuments = createAsyncThunk('appDashboard/getVehicleDocuments', async (GetVehicleDocuments) => {
    const response = await axios.post('https://api.zasway.com:8443/Dashboard/GetDashboardVehicleDocuments', GetVehicleDocuments, { mode: 'cors' })
    return response.data
  })

  export const GetDataForLostItems = createAsyncThunk('LostandFound/GetTableSummary', async (data) => {
    const response = await axios.post('https://api.zasway.com:8443/LostandFound/GetTableSummary', data, {mode:'cors'})
    return response.data.allData
  })

export const appDashboardSlice = createSlice({
  name: 'appDashboard',
  initialState: {

    BookingsGraphData: [],
    BookingsGoalOverview: [],
    BookingsGoalOverviews: [],
    DashboardAllData: [],
    DashboardSources: []
  },
    reducers: {},
    extraReducers: builder => {
    builder

      .addCase(getBookingsGraph.fulfilled, (state, action) => {
        state.BookingsGraphData = action.payload.data
      })

      .addCase(getGoalOverview.fulfilled, (state, action) => {
          
        state.BookingsGoalOverview = action.payload.data
      })

      .addCase(getGoalOverviews.fulfilled, (state, action) => {
         
        state.BookingsGoalOverviews = action.payload.data[0]
      })

      .addCase(getDashboardSources.fulfilled, (state, action) => {
        state.DashboardSources = action.payload.data
      })

      .addCase(getDashboardAllData.fulfilled, (state, action) => {
        
        state.DashboardAllData = action.payload.data
      })
    }
  })
  
  export default appDashboardSlice.reducer